<ln-ln-pages-armor>
  <section body class="bg-beige bg-opacity-10">
    <div
      class="sm:border-t-opacity-10 sm:border-t-[2.5px] sm:border-t-beige sm:shadow-[0px_-2px_5px_0px_rgba(0,0,0,0.10)]"></div>
    <section class="mx-auto max-w-[1440px] px-[36px] sm:min-h-[600px] sm:px-[120px]">
      <button
        (click)="navigateBack()"
        class="flex max-w-fit items-center pt-[27px] transition duration-100 hover:scale-110 sm:pt-[27px]">
        <ln-ln-arrow-back-svg-icon [class]="'h-[24px] w-[p4px]'"></ln-ln-arrow-back-svg-icon>
        <span class="ml-[6px] font-['Roboto'] text-base font-normal text-cafe">{{
            'buttons.goBackToBlog' | transloco
          }}</span>
      </button>
<!--      <div class="flex flex-row items-center pt-[20px] font-['Roboto'] text-sm font-normal text-cafe sm:pt-[26px]">-->
<!--        <div>{{ 'buttons.blog' | transloco }}</div>-->
<!--        <ln-chevron-right-svg-icon [class]="'h-[20px] w-[20px]'"></ln-chevron-right-svg-icon>-->
<!--        <div>{{ serviceName() | transloco }}</div>-->
<!--      </div>-->

<!--      <div class="pt-[20px] sm:pt-[22px]">-->
<!--        @if (imagePath()) {-->
<!--          <ln-ln-image-frame-->
<!--            [src]="imagePath()!"-->
<!--            alt="Imagen del producto"-->
<!--            [class]="'h-[220px] w-full object-cover sm:h-[346px]'">-->
<!--          </ln-ln-image-frame>-->
<!--        }-->
<!--      </div>-->

<!--      <div class="pb-[15px] pt-[15px] text-2xl font-semibold text-verde sm:pb-[20px] sm:pt-[40px]">-->
<!--        {{ serviceName() | transloco }}-->
<!--      </div>-->

<!--      <div class="text-base font-semibold">-->
<!--        {{ serviceNameQuestion() | transloco }}-->
<!--      </div>-->

<!--      <div class="py-[15px] text-base font-normal">-->
<!--        {{ serviceAnswerP1() | transloco }}-->
<!--      </div>-->

<!--      <div class="py-[15px] text-base font-normal">-->
<!--        {{ serviceAnswerP2() | transloco }}-->
<!--      </div>-->

<!--      <div class="py-[15px] text-base font-normal">-->
<!--        {{ serviceAnswerP3() | transloco }}-->
<!--      </div>-->

<!--      <div class="pt-[15px] text-base font-normal">-->
<!--        {{ serviceAnswerP4() | transloco }}-->
<!--      </div>-->



    </section>



    <div class="mx-auto max-w-[1440px] px-[36px] sm:px-[120px] mt-[40px]">
      <div class="flex flex-col  pt-[40px]  items-center border-b-[2px] border-b-verde opacity-40">

      </div>
    </div>

  </section>
</ln-ln-pages-armor>

